import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import {
  GetPermitToDigsByPermitRegisterId,
  GetPermitToDigsByPermitRegisterIdVariables,
} from "./__generated__/GetPermitToDigsByPermitRegisterId";
import { PERMIT_TO_DIG_LIST_FIELDS } from "../fragments/permitToDig";

export const GET_PERMIT_TO_DIGS_BY_PERMIT_REGISTER_ID = gql`
  ${PERMIT_TO_DIG_LIST_FIELDS}
  query GetPermitToDigsByPermitRegisterId(
    $permitRegisterId: String!
    $searchString: String
    $skip: Int
    $take: Int
    $stateKey: StateKey
    $assignedToId: String
    $createdById: String
    $asBuiltRequired: Boolean
    $permitTypeId: String
  ) {
    permitToDigsByPermitRegisterId(
      permitRegisterId: $permitRegisterId
      searchString: $searchString
      skip: $skip
      take: $take
      stateKey: $stateKey
      assignedToId: $assignedToId
      createdById: $createdById
      asBuiltRequired: $asBuiltRequired
      permitTypeId: $permitTypeId
    ) {
      totalCount
      items {
        ...PermitToDigListFields
      }
    }
  }
`;

export function useLazyGetPermitToDigsByPermitRegisterId() {
  const [getPermitToDigsByPermitRegisterId, { loading, error, data, refetch }] = useLazyQuery<
    GetPermitToDigsByPermitRegisterId,
    GetPermitToDigsByPermitRegisterIdVariables
  >(GET_PERMIT_TO_DIGS_BY_PERMIT_REGISTER_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getPermitToDigsByPermitRegisterId,
    data,
    status: { loading, errors: getErrors(error), successful: !error && data ? true : false } as AsyncQueryStatus,
    refetch,
  };
}
